import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { HiringManagersPopoverComponent } from './hiring-managers-popover.component';

@NgModule({
  declarations: [HiringManagersPopoverComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot()
  ],
  exports: [HiringManagersPopoverComponent],
  entryComponents: [HiringManagersPopoverComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class HiringManagersPopoverModule { }
